import AxiosFetchData from "../pages/AxiosFetchData";
import  { useState, useEffect, useCallback} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton';
import Helper from "../pages/Helper";
import React  from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import DatePicker from 'react-datepicker'; 
import Select, { SelectChangeEvent } from '@mui/material/Select';
import axios from "axios";
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { darken, lighten } from '@mui/material/styles';
import {apiUrl} from '../pages/UrlParam'; 
import DeleteIcon from '@mui/icons-material/Delete';

export const useListPOEngHook = () =>{
    const [project, setProject] = useState({});
    const [confirmDetailOpen, setConfirmDetailOpen] = useState('');
    const [confirmDelegasiOpen, setConfirmDelegasiOpen] = useState('');
    const [statusList, setStatusList] = useState([]);
    const Navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [rowsDelegasi, setRowsDelegasi] = useState([]);
    const [dataPO, setDataPO] = useState([]);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState('');
    const [deleteId, setDeleteId] = useState('');
    const [deleteName ,setDeleteName] = useState('');
    const [user, setUser] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedData, setSelectedData] = useState({});
    const open = Boolean(anchorEl);
    const [message, setmessage] = useState('');
    const [tipe, settipe] = useState('');
    const [roleAccess, setRoleAccess] = useState([]);
    const [openAliast, setOpenAlias] = useState(false)
    const [selectedOptionStatus,setSelectedOptionStatus] = useState(0)
    const [listStatus,setListStatus] = useState([])
    const [openAdd,setOpenAdd] = useState(false)
    const [openEdit,setOpenEdit] = useState(false)
    const [projectData,setProjectData] = useState({})
   //   const [openEdit,setOpenEdit] = useState(false)
    
      const handleClick = (event, data) => {
        setSelectedData(data)
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
    
      useEffect(() => {
        GetStatus();
        fetchData(); 
        GetListStatus(2)
       // setSelectedOptionStatus(2)
      }, []);

      const fetchData = async () => {
        try {
          const response = await AxiosFetchData.get("GetListPOEng").refreshToken(Navigate,"projectse");
          if(response){
            setUser(response.decode)
            setRoleAccess(response.roleaccess)
            // Add row numbers to the rows
            const rowsWithRowNumbers = response.data.map((row, index) => ({
            ...row,
            rowNumber: index + 1, 
            }));
            console.log(rows)
            setRows(rowsWithRowNumbers);
          }
        
        } catch (error) {
          setmessage(error.message)
          settipe('errorlog')
       
        }
      };

      const [filterModel, setFilterModel] = useState({
          items: [],
          quickFilterExcludeHiddenColumns: true,
          quickFilterValues: [''],
        });
        
        const [filterModel2, setFilterModel2] = useState({
          items: [],
          quickFilterExcludeHiddenColumns: true,
          quickFilterValues: [''],
        });
        
        const [columnVisibilityModel, setColumnVisibilityModel] = useState({id :false,id_project:false,assigned_by:false,updated_by:false});
        
        const StatusList = ({data}) => {
    
            return (
                <FormControl fullWidth>
                <Select
                value={data.statusid}
                id="demo-multiple-name"
                 labelId="demo-simple-select-label"
                //value={personName}
                 label="Level"
                 disabled={roleAccess.UPDATE == true ? ((data.id_resource == user.userID ||  (user.role === "SUPERADMIN")) ? false:true) : !roleAccess.UPDATE}
                onChange={(evt) => handleSelectedStatus(evt, data)}
                >
                {statusList.map((name) => (
                  <MenuItem
                    key={name.value}
                    value={name.value}
                    
                  >
                    {name.label}
                  </MenuItem>
                ))}
              </Select>
          </FormControl>
            );
          };
        
          function getKemajuan(params) {
              return  params.row.ratakemajuan ? (parseInt(params.row.ratakemajuan)).toFixed(2) + '%' : '0.00%';   
          }
    
          const columns = [
            { field: 'rowNumber', headerName: 'No.', width: 50 },
            {
              field: 'actions',
              headerName: '',
              width: 80,
              sortable: false,
              filterable: false ,
              renderCell: (params) => (
                <>
               
                 {((user.userID === params.row.id_resource) ||  (user.role === "SUPERADMIN")||  (user.role === "DIRECTOR")) && (
                  <div style={{display:'flex'}}>
                    <div>
                       <Button
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={(evt) => handleClick(evt, params.row)}
                >
                 <MoreVertIcon  sx={{ fontSize: 30 }}/>
                </Button>
                <Menu
                   PaperProps={{
                    sx: {
                      boxShadow: (theme) => theme.shadows[2],
                    }
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  sx={{width: 200,boxShadow:0}}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  
                  {/* <MenuItem style={{width:200}}  onClick={() => handleEdit(selectedData.id_project)} >RAK</MenuItem> */}
                  <MenuItem  onClick={() => handleTaskList(selectedData)}>TASK</MenuItem>
                  {/* <MenuItem onClick={() => handleInvoice(selectedData.id_project)}>INVOICE</MenuItem> */}
                  <MenuItem onClick={() => Navigate(`/PO/${selectedData.id_project}${Helper.SetReturnUrl()}`)}>WORK LIST / PO</MenuItem>
                  {/* <MenuItem  onClick={() => Navigate(`/RequestMaterial/${selectedData.id_project}${Helper.SetReturnUrl()}`)}>REQUEST MATERIAL</MenuItem> */}
                  <MenuItem  disabled={!roleAccess.UPDATE} onClick={() => {
                    setAnchorEl(false)
                    setOpenAlias(true)}
                    }>ALIAS</MenuItem>
                    <MenuItem  disabled={!roleAccess.UPDATE} onClick={async () => {
                        let resp = await AxiosFetchData.get(`GetAllMomByProjectId/${selectedData.id_project}`).refreshToken(Navigate)
                        if(resp.data != null){
                            setOpenEdit(true)
                            
                            resp.data.alias_project = selectedData.alias_project
                            setProjectData(resp.data)
                        }else{
                            setOpenAdd(true)
                            setProjectData(selectedData)
                        }
                         setAnchorEl(false)
                        //Navigate('/MOM/' + selectedData.id + '?ReturnUrl=ListPOV2')
                    }} >M.O.M</MenuItem>
                </Menu>
                </div>
                  
                <div>
                <ConfirmationButton classname='btn btn-danger hide' text="Do you want delete this data?" type="button" onClick={() => handleDeleteConfirmation(params.row.id_project)}>
                <DeleteIcon sx={{ fontSize: 10}}/> Delete
                     </ConfirmationButton>
                     </div>
                </div>
                )}
                </>
                
              ),
          
          
              
            },
           
            { field: 'id', headerName: 'ID', width: 50 },
            { field: 'id_project', headerName: 'ID', width: 150 },
             { field: 'customername', headerName: 'Customer  Name', width: 250 },
            // { field: 'nama_project', headerName: 'Project Name', width: 250 },
             { field: 'alias_project', headerName: 'Project Alias', width: 250 },
            { field: 'totalpo', headerName: 'Project Value', width: 120, valueGetter:({ value }) => value && Helper.formatAsCurrency(value)},
            { field: 'faktur', headerName: 'Payment (Invoice)', width: 130,  valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
            { field: 'anggarantersisa', headerName: 'Outstanding Debt', width: 120, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
           
            { field: 'resourcename', headerName: 'Delegation', width: 150 },
            { field: 'levelname', headerName: 'Level', width: 100 },
            { field: 'prioritasname', headerName: 'Priority', width: 100 },
            { field: 'milestone', headerName: 'Milestones', width: 100 },
            { field: 'milestonedone', headerName: 'Milestone Done', width: 120 },
            { field: 'task', headerName: 'Tasks', width: 50 },
            { field: 'taskdone', headerName: 'Task Done', width: 100 },
            {
              field: 'ratakemajuan',
              headerName: 'Progress',
              width: 120,
              valueGetter: getKemajuan,
            },
            { field: 'project_start', headerName: 'Start', width: 100,  type: 'string',
             },
            { field: 'project_end', headerName: 'End', width: 100, type: 'string',
               },
            {
              field: 'actions2',
              headerName: 'Status',
              width: 150,
              sortable: false,
              filterable: false ,
              renderCell: (params) => <StatusList data={params.row}/>,
            },
            { field: 'assigned_by', headerName: 'Delegated By', width: 150 },
            { field: 'updated_by', headerName: 'Updated By', width: 150 },
            
          
          ];

          const columnsDelegasi = [
            { field: 'rowNumber', headerName: 'No.', width: 80 },
            { field: 'nama_client', headerName: 'ID', width: 200 },
             
           {
              field: 'actions',
              headerName: 'Actions',
              width: 170,
              renderCell: (params) => (
                <>
                   <button
                    onClick={() => handleDelegasi(params.row.id)} // Pass the project ID to the edit function
                    className="btn btn-primary mr-2"
                   >
                    Pilih
                  </button>
               
                </>
                
              ),
          
          
              
            },
          
          ];
        
         
         const handleTaskList = async (params) => {
          Navigate(`/TaskList/${params.id_project}?ReturnUrl=ListPOEng`);
           // Navigate(`/TaskList`);
         }

         const handleDeleteConfirmation = async (id) => {
   
            try {
              const response = await AxiosFetchData.delete(`DeleteProject/${id}`).refreshToken(Navigate,"projectse");
              if(response){
               
                setRows((prevRows) => prevRows.filter((row) => row.id_project !== id));
                //setConfirmDeleteOpen(false); // Close the confirmation modal after successful deletion
                setmessage(response.data)
              }
            
            } catch (error) {
              setmessage(error.message)
              settipe('errorlog')
              //console.error('Error fetching project data:', error);
            }
            
           
          };

          function handleSelectedStatus(event, data){
             
            var data = {
                 id_status : event.target.value,
                 id_project : data.id_project
            }
            
            AddProject(data);
            
         }

         async function handleDelegasi(id){
            //console.log(project)
            var data = {
                nama_project: project.subject,
                id_resource:id,
                id_client : project.customer_id,
                //anggaran : 5000000,
              //  tanggal_mulai : '2024-01-01',
              //  tanggal_selesai : '2024-01-01',
               // id_level : event.target.value,
                id_project : project.id,
               // id_prioritas:event.target.value,
           }
          AddProject(data)
          setConfirmDelegasiOpen(false);
        }
        
        
        async function AddProject(data){
          try{
            const response = await AxiosFetchData.post(`AddProject`, data).refreshToken(Navigate,"projectse");
            if(response){
                fetchData();
                setmessage(response.data);
            }
          }catch(e){
            setmessage(e.message);
            settipe('errorlog')
          }
          
        }

        function GetStatus(){
            axios.get(`${apiUrl}/api/GetStatus`)
            .then((response) => {
              const child = response.data.filter((item) =>item.parent_id !== 0).map((item) => item.parent_id)
              //console.log(Helper.RemoveDuplicateArr(child))
              // const transformedOptions = response.data.filter((item) =>!Helper.RemoveDuplicateArr(child).includes(item.id)).map((item) => ({
              //   label: `${item.id} - ${item.name}`,
              //   value: item.id,
              // }));
              const transformedOptions = response.data.map((item) => ({
                label: `${item.id} - ${item.name}`,
                value: item.id,
              }));
              setStatusList(transformedOptions);
              //return transformedOptions;
            })
            .catch((error) => {
              console.error('Error fetching category data:', error);
            });
             
        }

        const handleSelectedProject = async (option) =>{
            // const response = await AxiosFetchData.get(`GetStatusById/${option.value}`).refreshToken(Navigate,"projectse")
            // setListStatus(response.data)
              GetListStatus(option.value)
            //setSelectedOptionStatus(option.value)
        }

        const GetListStatus = async (option) =>{
            const response = await AxiosFetchData.get(`GetStatusById/${option}`).refreshToken(Navigate,"projectse")
            setListStatus(response.data)
            setSelectedOptionStatus(option)
        }

         let list = useCallback(rows.filter((item) => {
          // listStatus.forEach(element => {
            
          //     if(item.statusid == element)
          //     {
          //       console.log(item.statusid)
          //       console.log("berhasil")
          //       return true;
          //     }
          // });
          if(selectedOptionStatus == 0)
          {
            return true;
          }

          return listStatus.includes(item.statusid)
          
           
         }),[selectedOptionStatus,listStatus,rows])
       
        return {message,setmessage,tipe,settipe,columns,rows,filterModel,setFilterModel,columnVisibilityModel,setColumnVisibilityModel,confirmDetailOpen,setConfirmDetailOpen,dataPO,confirmDelegasiOpen,setConfirmDelegasiOpen,rowsDelegasi,filterModel2,setFilterModel2,columnVisibilityModel,setColumnVisibilityModel,confirmDeleteOpen,setConfirmDeleteOpen,deleteName,handleDeleteConfirmation,setConfirmDeleteOpen,columnsDelegasi,openAliast,setOpenAlias,GetStatus,fetchData, selectedData, selectedOptionStatus,setRows,handleSelectedProject,list,
          openAdd,setOpenAdd,openEdit,setOpenEdit,projectData
        }
}